import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const PartyReducer = createSlice({
  name: "Party",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("PartyReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = PartyReducer;
export const { defaultAction } = actions;
export default reducer;
